/**
 * Etiquetas en español para los datos del flujo del portal que se muestran en la
 * tabla de Clientes (columnas Estado y Tipo de validación). Espejo de los enums
 * del backend (PortalFormStatus / PortalValidationType).
 */

export const VALIDATION_TYPE_LABELS: Record<string, string> = {
  new_client: 'Cliente nuevo',
  expedient: 'Validación de expediente',
  revalidation: 'Revalidación de cliente',
  profile: 'Validación de perfil',
  equity: 'Flujo patrimonial'
}

/** Contexto/acción del flujo activo (filtro de la lista). Espejo del enum FlowContext. */
export const FLOW_CONTEXT_LABELS: Record<string, string> = {
  client_creation: 'Alta de cliente',
  client_validation: 'Validación de cliente existente',
  revalidation: 'Revalidación periódica'
}

export interface FlowStatusStyle {
  label: string
  className: string
}

/** Mapa de estado del flujo → etiqueta + color. `null` = sin flujo activo. */
export const FLOW_STATUS_STYLES: Record<string, FlowStatusStyle> = {
  draft: { label: 'Borrador', className: 'bg-blue-50 border-blue-200 text-blue-700' },
  sent: { label: 'Enviado', className: 'bg-sky-50 border-sky-200 text-sky-700' },
  opened: { label: 'Abierto', className: 'bg-sky-50 border-sky-200 text-sky-700' },
  in_progress: { label: 'Llenando', className: 'bg-amber-50 border-amber-200 text-amber-700' },
  submitted: {
    label: 'Enviado a revisión',
    className: 'bg-violet-50 border-violet-200 text-violet-700'
  },
  resubmitted: { label: 'Reenviado', className: 'bg-violet-50 border-violet-200 text-violet-700' },
  under_review: { label: 'En revisión', className: 'bg-amber-50 border-amber-200 text-amber-700' },
  changes_requested: {
    label: 'Correcciones',
    className: 'bg-orange-50 border-orange-200 text-orange-700'
  },
  approved: { label: 'Completado', className: 'bg-green-50 border-green-200 text-green-700' },
  rejected: { label: 'Rechazado', className: 'bg-red-50 border-red-200 text-red-700' },
  expired: { label: 'Expirado', className: 'bg-neutral-100 border-neutral-300 text-neutral-600' },
  revoked: { label: 'Cancelado', className: 'bg-red-50 border-red-200 text-red-700' }
}

export const NO_ACTIVE_FLOW_LABEL = 'Sin flujo activo'

export function validationTypeLabel(value: string | null | undefined): string {
  if (!value) return NO_ACTIVE_FLOW_LABEL
  return VALIDATION_TYPE_LABELS[value] ?? value
}

export const REVALIDATION_STATUS_STYLES: Record<string, { label: string; className: string }> = {
  up_to_date: { label: 'Al día', className: 'bg-green-50 border-green-200 text-green-700' },
  expired: { label: 'Vencido', className: 'bg-red-50 border-red-200 text-red-700' },
  in_progress: { label: 'En curso', className: 'bg-amber-50 border-amber-200 text-amber-700' },
  unverified: {
    label: 'Sin verificación',
    className: 'bg-neutral-100 border-neutral-300 text-neutral-600'
  },
  closed: {
    label: 'Contrato firmado',
    className: 'bg-blue-50 border-blue-200 text-blue-700'
  }
}
